/* ZEEKEYS section translations and manual first-visit language selection. ES5 JavaScript. */
(function () {
  'use strict';

  var languages = ['en', 'es', 'de', 'fr', 'ja', 'ar'];
  var locales = {en:'en-US', es:'es-ES', de:'de-DE', fr:'fr-FR', ja:'ja-JP', ar:'ar-SA'};
  var languageGateKey = 'zeekeys-language-gate-v4';
  var languagePendingKey = 'zeekeys-language-selection-pending-v2';
  var attributes = ['alt', 'title', 'placeholder', 'aria-label', 'aria-description'];
  var dictionaries = [];
  var initial = normalize(document.documentElement.lang);
  var language = contains(languages, initial) ? initial : 'en';

  function contains(list, value) { return list.indexOf(value) !== -1; }
  function normalize(value) { return String(value || '').toLowerCase().split('-')[0]; }
  function toArray(list) { return Array.prototype.slice.call(list || []); }
  function hasAttribute(node, name) {
    return !!(node && node.nodeType === 1 && node.hasAttribute && node.hasAttribute(name));
  }
  function scopeOf(node) {
    var current = node;
    while (current && current !== document) {
      if (hasAttribute(current, 'data-zk-i18n-scope') ||
          (current.nodeType === 1 && /(^|\s)shopify-section(\s|$)/.test(current.getAttribute('class') || ''))) return current;
      current = current.parentNode;
    }
    return document;
  }
  function dictionaryFor(scope) {
    var i;
    for (i = 0; i < dictionaries.length; i++) if (dictionaries[i].scope === scope) return dictionaries[i].data;
    return null;
  }
  function collectTranslations(root) {
    var scripts, scopes, i, j, scope, scopeScripts, data, key, value, dictionary, found;
    root = root || document;
    scripts = toArray(root.querySelectorAll('script[data-zk-section-i18n]'));
    if (hasAttribute(root, 'data-zk-section-i18n')) scripts.unshift(root);
    scopes = [];
    for (i = 0; i < scripts.length; i++) {
      scope = scopeOf(scripts[i]);
      if (!contains(scopes, scope)) scopes.push(scope);
    }
    if (root === document) dictionaries = [];
    for (i = 0; i < scopes.length; i++) {
      scope = scopes[i];
      dictionary = Object.create(null);
      scopeScripts = toArray(scope.querySelectorAll('script[data-zk-section-i18n]'));
      for (j = 0; j < scopeScripts.length; j++) {
        if (scopeOf(scopeScripts[j]) !== scope) continue;
        try {
          data = JSON.parse(scopeScripts[j].textContent);
          if (!data || Object.prototype.toString.call(data) !== '[object Object]') throw new Error('Expected translation object');
          for (key in data) {
            if (!Object.prototype.hasOwnProperty.call(data, key)) continue;
            value = data[key];
            if (!value || Object.prototype.toString.call(value) !== '[object Object]') continue;
            if (Object.prototype.hasOwnProperty.call(dictionary, key) && window.console) console.warn('Duplicate ZEEKEYS translation key', key);
            dictionary[key] = value;
          }
        } catch (error) { if (window.console) console.warn('Invalid ZEEKEYS translation dictionary', error); }
      }
      found = false;
      for (j = 0; j < dictionaries.length; j++) {
        if (dictionaries[j].scope === scope) { dictionaries[j].data = dictionary; found = true; break; }
      }
      if (!found) dictionaries.push({scope:scope, data:dictionary});
    }
    for (i = dictionaries.length - 1; i >= 0; i--) {
      if (dictionaries[i].scope !== document &&
          !document.documentElement.contains(dictionaries[i].scope)) dictionaries.splice(i, 1);
    }
  }
  function translation(key, element) {
    var scope = !element || element === document ? document : scopeOf(element);
    var dictionary, entry, value;
    while (scope) {
      dictionary = dictionaryFor(scope);
      entry = dictionary && dictionary[key];
      value = entry && (entry[language] || entry.en);
      if (typeof value === 'string' && value.length) return value;
      scope = scope === document ? null : scopeOf(scope.parentNode);
    }
    return '';
  }
  function render(root) {
    var elements, selects, codes, i, element, value, attribute;
    root = root || document;
    elements = toArray(root.querySelectorAll('[data-zk-i18n-key]'));
    if (hasAttribute(root, 'data-zk-i18n-key')) elements.unshift(root);
    for (i = 0; i < elements.length; i++) {
      element = elements[i];
      value = translation(element.getAttribute('data-zk-i18n-key'), element);
      if (!value) continue;
      attribute = element.getAttribute('data-zk-i18n-attr');
      if (attribute) {
        if (contains(attributes, attribute)) element.setAttribute(attribute, value);
      } else if (element.hasAttribute('data-zk-i18n-html')) {
        // Only theme-owned rich text dictionaries may opt into HTML mode.
        if (element.innerHTML !== value) element.innerHTML = value;
      } else if (element.textContent !== value) element.textContent = value;
    }
    selects = root.querySelectorAll('[data-zk-language-select]');
    for (i = 0; i < selects.length; i++) selects[i].value = language;
    codes = root.querySelectorAll('[data-zk-language-code]');
    for (i = 0; i < codes.length; i++) codes[i].textContent = language.toUpperCase();
  }
  function emitLanguageChange(root) {
    var detail = {language:language, locale:locales[language], root:root};
    var event;
    try { event = new CustomEvent('zk:language:change', {detail:detail}); }
    catch (error) {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent('zk:language:change', false, false, detail);
    }
    document.dispatchEvent(event);
  }
  function applyLanguage(value, root) {
    var next = normalize(value);
    root = root || document;
    if (!contains(languages, next)) return;
    language = next;
    document.documentElement.lang = language;
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    document.body.setAttribute('data-zk-language', language);
    render(root);
    emitLanguageChange(root);
  }
  function refresh(root) { root = root || document; collectTranslations(root); applyLanguage(language, root); }
  function cookieValue(name) {
    var parts, i, part, prefix = name + '=';
    try {
      parts = document.cookie.split(';');
      for (i = 0; i < parts.length; i++) {
        part = parts[i].replace(/^\s+/, '');
        if (part.indexOf(prefix) === 0) return decodeURIComponent(part.slice(prefix.length));
      }
    } catch (error) {}
    return '';
  }
  function rememberLanguage(next) {
    try {
      localStorage.setItem('zeekeys-language', next);
      localStorage.setItem(languageGateKey, 'complete');
    } catch (error) {}
    try {
      document.cookie = 'zeekeys-language=' + encodeURIComponent(next) + '; Max-Age=31536000; Path=/; SameSite=Lax; Secure';
      document.cookie = languageGateKey + '=complete; Max-Age=31536000; Path=/; SameSite=Lax; Secure';
    } catch (error) {}
  }
  function closestWithAttribute(node, name) {
    while (node && node !== document) {
      if (hasAttribute(node, name)) return node;
      node = node.parentNode;
    }
    return null;
  }
  function initLanguageGate() {
    var gate = document.querySelector('[data-zk-language-gate]');
    var form, input, completed = false, submitting = false, pending;
    function releaseMarketSync() {
      var api = window.ZeekeysCountry;
      window.__zeekeysLanguageGatePending = false;
      if (api && typeof api.syncMarket === 'function') {
        api.syncMarket(typeof api.get === 'function' ? api.get() : null);
      }
    }
    if (!gate) { releaseMarketSync(); return; }
    try { completed = localStorage.getItem(languageGateKey) === 'complete'; } catch (error) {}
    completed = completed || cookieValue(languageGateKey) === 'complete';
    form = gate.querySelector('form');
    input = form && form.querySelector('input[name="language_code"]');
    if (!form || !input) { releaseMarketSync(); return; }

    function clearPending() {
      try { sessionStorage.removeItem(languagePendingKey); } catch (error) {}
      try { document.cookie = languagePendingKey + '=; Max-Age=0; Path=/; SameSite=Lax; Secure'; } catch (error) {}
    }
    function pendingLanguage() {
      var value = '';
      try { value = sessionStorage.getItem(languagePendingKey) || ''; } catch (error) {}
      if (!value) value = cookieValue(languagePendingKey);
      return contains(languages, value) ? value : '';
    }
    function setPending(next) {
      var saved = false;
      try { sessionStorage.setItem(languagePendingKey, next); saved = sessionStorage.getItem(languagePendingKey) === next; } catch (error) {}
      try {
        document.cookie = languagePendingKey + '=' + next + '; Max-Age=120; Path=/; SameSite=Lax; Secure';
        saved = saved || pendingLanguage() === next;
      } catch (error) {}
      return saved;
    }
    function finish(next) {
      clearPending();
      rememberLanguage(next);
      releaseMarketSync();
    }
    function showGate() {
      var currentOption;
      if (!gate.hidden) return;
      gate.hidden = false;
      try { gate.showModal(); } catch (error) { gate.setAttribute('open', ''); }
      document.documentElement.classList.add('zk-language-gate-open');
      currentOption = gate.querySelector('.is-current') || gate.querySelector('[data-zk-language-gate-option]');
      if (currentOption) setTimeout(function () { currentOption.focus(); }, 0);
    }
    function dismiss() {
      if (typeof gate.close === 'function' && gate.open) gate.close();
      gate.hidden = true;
      document.documentElement.classList.remove('zk-language-gate-open');
    }
    function choose(value) {
      var next = normalize(value), watchdog;
      if (!contains(languages, next) || submitting) return false;
      if (next === language) { finish(next); dismiss(); return true; }
      if (!setPending(next)) { showGate(); return false; }
      input.value = value;
      submitting = true;
      // Native submission avoids handlers intercepting the Shopify localization form.
      try {
        HTMLFormElement.prototype.submit.call(form);
        watchdog = setTimeout(function () {
          submitting = false;
          clearPending();
          showGate();
        }, 8000);
        window.addEventListener('pagehide', function () { clearTimeout(watchdog); });
        return true;
      } catch (error) { submitting = false; clearPending(); showGate(); return false; }
    }
    gate.addEventListener('click', function (event) {
      var option = closestWithAttribute(event.target, 'data-zk-language-gate-option');
      if (!option || !gate.contains(option)) return;
      event.preventDefault();
      event.stopPropagation();
      choose(option.value);
    }, true);
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopPropagation();
      choose(event.submitter ? event.submitter.value : input.value);
    }, true);
    gate.addEventListener('cancel', function (event) { event.preventDefault(); });

    pending = pendingLanguage();
    if (pending) {
      clearPending();
      if (pending === language) {
        finish(language);
      } else {
        showGate(); // Shopify did not apply the requested locale; let the visitor choose again.
      }
      return;
    }
    if (completed) { releaseMarketSync(); return; }
    showGate();
  }
  function init() {
    refresh();
    initLanguageGate();
    document.addEventListener('change', function (event) {
      var select = closestWithAttribute(event.target, 'data-zk-language-select');
      var next;
      if (!select || !select.form) return;
      next = normalize(select.value);
      if (!contains(languages, next)) return;
      rememberLanguage(next);
      // Shopify/URL is authoritative. Do not replace UI before navigation succeeds.
      if (select.form.requestSubmit) select.form.requestSubmit(); else select.form.submit();
    });
    document.addEventListener('shopify:section:load', function (event) { refresh(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      var i;
      for (i = dictionaries.length - 1; i >= 0; i--) {
        if (dictionaries[i].scope === event.target || event.target.contains(dictionaries[i].scope)) dictionaries.splice(i, 1);
      }
    });
    document.addEventListener('zk:content:loaded', function (event) { refresh(event.detail && event.detail.root ? event.detail.root : document); });
  }
  window.ZeekeysI18n = {collectTranslations:collectTranslations, translation:translation, applyLanguage:applyLanguage, refresh:refresh};
  Object.defineProperty(window.ZeekeysI18n, 'language', {get:function () { return language; }});
  Object.defineProperty(window.ZeekeysI18n, 'locale', {get:function () { return locales[language]; }});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
}());
